import { Component, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router'

@Component({
  templateUrl: './template/usernameAccount.component.html',
  styles: [`
    em { float:right; color:#E05C65; padding-left:10px; }
  `]
})
export class UsernameAccount implements OnInit {
  userName
  mouseoverLogin
  forgotPasswordForm: UntypedFormGroup;


  constructor( private router:Router, private formBuilder: UntypedFormBuilder,)
 {}
  ngOnInit(): void {

    this.forgotPasswordForm = this.formBuilder.group(
      {
        username: ["", [Validators.required]],
      }
    );


  }

  get f() { return this.forgotPasswordForm.controls; }


  forgotPassword(formValues) {
    
    this.userName=formValues.userName
      

    //Todo To call Post Service
    //this.claimService.postClaimData(this.claim).subscribe();
    //To send data to subscriber
    //this.subjectPasswordService.sendUserNameData(this.userName)
    this.router.navigate(['updateAccount'])
  }
}
